export class FreezeUnFreezeInfoReq{
    tabName : string

    constructor(tabName: string){
        this.tabName = tabName
    }
}